import PropTypes from 'prop-types';
import React from 'react';

const SaveButton = ({ content, disabled, className }) => (
  <button disabled={disabled} className={className} type="submit" data-automation-id="button:save">
    <span className="c-btn__text">{ content }</span>
  </button>
);

SaveButton.propTypes = {
  content: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

SaveButton.defaultProps = {
  disabled: false,
  className: 'c-btn u-width-120',
};

export default SaveButton;
